import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg } from 'src/components/svg/SvgStyles';


export default function PersonIconSvg({ className }: StandardSvgProps) {
	return (
		<SDefaultSvg className={className} width="17.858" height="23.866" viewBox="0 0 17.858 23.866">
			<path d="M1875.6,930.512a5.311,5.311,0,1,1,5.311,5.38A5.311,5.311,0,0,1,1875.6,930.512Zm14.249,15.09a12.98,12.98,0,0,1-17.8,0c-.3-4.3,1.849-8.285,5.3-8.285h7.211C1888,937.317,1890.144,941.3,1889.847,945.6Z" transform="translate(-1872.016 -925.27)" />
		</SDefaultSvg>
	);
}